import { FC, useEffect } from 'react';
import { useFlashTransition } from '__hooks/useFlashState';
import TextInput from '__components/Inputs/TextInput';
import { useTranslation } from 'react-i18next';

export const WebhookURLInput: FC<{
  value?: string | null;
  error?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled: boolean;
}> = ({ value, error, onChange, onBlur, disabled }) => {
  const { t } = useTranslation();
  const [, showErrorMessage, flashError, cancelFlash] = useFlashTransition();

  useEffect(() => {
    if (error) {
      flashError(error);
    }
  }, [error, flashError]);

  const handleChange = (v: string) => {
    onChange(v);
    cancelFlash();
  };

  return (
    <TextInput
      value={value}
      error={error}
      validate={{
        message: error,
        showMessage: showErrorMessage,
      }}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled}
      labelInfoPlacement="top"
      placeholder={t('Webhook URL')}
      labelInfo={t(
        'This webhook will be called with a POST when an Execution ends with any status including success, failed, and canceled.'
      )}
      label={t('Webhook URL: Execution Ended')}
    />
  );
};
